module.exports = __webpack_public_path__ + "img/rg8.4b4e1e73.jpg";